import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const values = [
  { icon: 'ri-shield-check-line', title: 'Quality First', desc: 'We never cut corners. Every job is completed to the highest standard, using premium materials and proven techniques.' },
  { icon: 'ri-shake-hands-line', title: 'Honest & Transparent', desc: 'Clear quotes, honest advice, and no surprises. We build long-term relationships based on trust.' },
  { icon: 'ri-time-line', title: 'Reliable & On-Time', desc: 'We show up when we say we will and finish on schedule. Your time is valuable and we respect that.' },
  { icon: 'ri-heart-line', title: 'Community Focused', desc: 'We give back to the communities we serve through our Community Homes Program and volunteer work.' },
];

const team = [
  {
    name: 'Marco Alvarez',
    role: 'Founder & Lead Painter',
    bio: 'With over 15 years of experience in painting and decorating across New Zealand and Europe, Marco founded ALFA Decorators with a vision to bring premium quality to Wellington homes.',
    image: 'https://readdy.ai/api/search-image?query=professional%20friendly%20male%20painter%20decorator%20Wellington%20New%20Zealand%20founder%20business%20owner%20confident%20smile%20natural%20light%20portrait%20professional%20headshot%2040%20years%20old&width=400&height=400&seq=team2001&orientation=squarish',
  },
  {
    name: 'Sofia Reyes',
    role: 'Project Manager',
    bio: 'Sofia ensures every project runs smoothly from start to finish. Her attention to detail and client communication skills keep our customers informed and happy throughout the process.',
    image: 'https://readdy.ai/api/search-image?query=professional%20friendly%20female%20project%20manager%20Wellington%20New%20Zealand%20business%20professional%20confident%20smile%20natural%20light%20portrait%20headshot%2035%20years%20old&width=400&height=400&seq=team2002&orientation=squarish',
  },
  {
    name: 'James Tane',
    role: 'Senior Painter & Spray Specialist',
    bio: 'James is our fine finish spraying expert with 10 years of experience. His precision and skill deliver the flawless results our clients love, especially on cabinetry and architectural features.',
    image: 'https://readdy.ai/api/search-image?query=professional%20friendly%20male%20Maori%20painter%20spray%20specialist%20Wellington%20New%20Zealand%20skilled%20tradesperson%20confident%20smile%20natural%20light%20portrait%20headshot%2032%20years%20old&width=400&height=400&seq=team2003&orientation=squarish',
  },
];

const milestones = [
  { year: '2020', event: 'ALFA Decorators founded in Wellington' },
  { year: '2021', event: 'Expanded to Hutt Valley, team grew to 2 painters' },
  { year: '2022', event: 'Introduced fine finish spraying service' },
  { year: '2023', event: 'Completed 150th project milestone' },
  { year: '2026', event: '300+ projects, 5 team members strong' },
];

export default function AboutPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero */}
      <section
        className="relative pt-32 pb-20"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=professional%20painting%20team%20Wellington%20New%20Zealand%20painters%20at%20work%20exterior%20house%20painting%20skilled%20tradespeople%20uniform%20sunny%20day%20premium%20quality%20service%20team%20photo&width=1440&height=500&seq=abthero001&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
        }}
      >
        <div className="absolute inset-0 bg-[#1C1C1C]/80" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 text-center">
          <span className="inline-block text-gray-400 text-sm font-semibold tracking-widest uppercase mb-4">Our Story</span>
          <h1 className="text-5xl md:text-6xl font-black text-white mb-5 tracking-tight">About ALFA Decorators</h1>
          <p className="text-white/70 text-lg max-w-2xl mx-auto">
            Wellington's trusted painting and decorating experts since 2014.
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="flex flex-col lg:flex-row gap-14 items-center">
            <div className="w-full lg:w-[45%]">
              <div className="rounded-2xl overflow-hidden h-[460px]">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20painting%20team%20Wellington%20New%20Zealand%20painters%20working%20together%20interior%20painting%20skilled%20tradespeople%20uniform%20natural%20light%20quality%20workmanship%20team%20collaboration&width=700&height=460&seq=abt2001&orientation=portrait"
                  alt="ALFA Decorators team Wellington"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="w-full lg:w-[55%]">
              <span className="inline-block text-[#2D2D2D] text-sm font-semibold tracking-widest uppercase mb-4">Who We Are</span>
              <h2 className="text-4xl font-black text-gray-900 mb-6 tracking-tight leading-tight">
                Wellington's Trusted Painting & Decorating Experts
              </h2>
              <p className="text-gray-600 text-base leading-relaxed mb-5">
                Trusted painting professionals in Wellington &amp; Hutt Valley since 2020.
ALFA Decorators began as a one-man operation with a clear goal — to deliver high-quality painting and decorating services homeowners can rely on. Today, we’re a growing team of skilled professionals proudly serving Wellington and the Hutt Valley.
We understand your home is one of your biggest investments. That’s why we combine expert techniques with meticulous attention to detail on every project. Whether it’s a single room or a full exterior repaint, we treat every home as if it were our own.
Our team is known for being reliable, clean, and committed to delivering results that not only look great but last for years.
Proudly supporting over 200 homes and community spaces across Wellington &amp; Hutt Valley.
              </p>
              <p className="text-gray-600 text-base leading-relaxed mb-8">
                We combine professional technique with meticulous attention to detail. Whether it's a single room refresh or a full exterior repaint, our experienced team treats every project as if it were our own home. We use only premium materials and proven methods to ensure results that look great and last for years.
              </p>
              <div className="flex flex-wrap gap-8">
                {[
                  { value: '300+', label: 'Projects Completed' },
                  { value: '10+', label: 'Years Experience' },
                ].map((stat) => (
                  <div key={stat.label}>
                    <div className="text-3xl font-black text-[#2D2D2D]">{stat.value}</div>
                    <div className="text-gray-500 text-sm mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-[#F5F5F5]">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="text-center mb-12">
            <span className="inline-block text-[#2D2D2D] text-sm font-semibold tracking-widest uppercase mb-3">What We Stand For</span>
            <h2 className="text-4xl font-black text-gray-900 tracking-tight">Our Values</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((v) => (
              <div key={v.title} className="bg-white rounded-2xl p-7">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#F0F0F0] mb-5">
                  <i className={`${v.icon} text-[#2D2D2D] text-xl`} />
                </div>
                <h3 className="font-bold text-gray-900 text-base mb-3">{v.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-20 bg-[#F5F5F5]">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <div className="text-center mb-12">
            <span className="inline-block text-[#2D2D2D] text-sm font-semibold tracking-widest uppercase mb-3">Our Journey</span>
            <h2 className="text-4xl font-black text-gray-900 tracking-tight">5 Years of Excellence</h2>
          </div>
          <div className="relative">
            <div className="absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-0.5 bg-[#E5E5E5]" />
            <div className="space-y-8">
              {milestones.map((m, i) => (
                <div key={m.year} className={`flex items-center gap-6 ${i % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                  <div className={`w-[calc(50%-2rem)] ${i % 2 === 0 ? 'text-right' : 'text-left'}`}>
                    <div className="text-2xl font-black text-[#2D2D2D]">{m.year}</div>
                    <p className="text-gray-600 text-sm mt-1">{m.event}</p>
                  </div>
                  <div className="relative z-10 w-4 h-4 rounded-full bg-[#2D2D2D] border-4 border-white flex-shrink-0" />
                  <div className="w-[calc(50%-2rem)]" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#1C1C1C] text-center">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <h2 className="text-3xl font-black text-white mb-4 tracking-tight">Ready to work with us?</h2>
          <p className="text-white/60 text-lg mb-8">Get a free, no-obligation quote from our team today.</p>
          <a
            href="/contact"
            onClick={(e) => { e.preventDefault(); navigate('/contact'); }}
            className="inline-flex items-center gap-2 px-10 py-4 bg-white text-[#1C1C1C] font-bold rounded-full whitespace-nowrap hover:bg-gray-100 transition-colors cursor-pointer text-base"
          >
            Get a Free Quote <i className="ri-arrow-right-line" />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
